<app-modal
  [visible]="visible"
  [header]="'Additional Information for Download Request'"
  [width]="'700px'"
  [showFooter]="false"
  (visibleChange)="onClose()"
>
  <div class="request-access-modal-content">
    <div class="request-access-modal--leaf-pattern">
      <img src="/assets-leaf.png" alt="" class="request-access-modal--leaf-image" />
    </div>
    <div class="request-access-modal--body">

      <!-- User has no organisation: show Individual / Organisation choice -->
      <ng-container *ngIf="!userHasOrganisation">
        <div class="request-access-modal--field request-access-modal--field-first">
          <label class="request-access-modal--label">Request as</label>
          <div class="request-access-modal--radio-group request-access-modal--radio-group-cards">
            <label
              class="request-access-modal--radio-card"
              [class.request-access-modal--radio-card-selected]="requestAs === 'Individual'"
            >
              <input
                type="radio"
                name="requestAs"
                value="Individual"
                [(ngModel)]="requestAs"
                class="request-access-modal--radio-input"
              />
              <span class="request-access-modal--radio-dot"></span>
              <span class="request-access-modal--radio-card-label">Individual</span>
            </label>
            <label
              class="request-access-modal--radio-card"
              [class.request-access-modal--radio-card-selected]="requestAs === 'Organisation'"
            >
              <input
                type="radio"
                name="requestAs"
                value="Organisation"
                [(ngModel)]="requestAs"
                class="request-access-modal--radio-input"
              />
              <span class="request-access-modal--radio-dot"></span>
              <span class="request-access-modal--radio-card-label">Organisation</span>
            </label>
          </div>
        </div>

        <div
          class="request-access-modal--field request-access-modal--join-org-cta"
          *ngIf="requestAs === 'Organisation'"
        >
          <div class="request-access-modal--join-org-box">
            <p class="request-access-modal--join-org-text">
              You need to join or create an organisation to request access as an organisation.
            </p>
            <button
              type="button"
              class="request-access-modal--join-org-link"
              (click)="goToJoinOrganisation()"
            >
              Join or Create an Organisation
            </button>
          </div>
        </div>

        <ng-container *ngIf="requestAs === 'Individual'">
          <div class="request-access-modal--field">
            <label class="request-access-modal--label">
              Purpose
              <span class="request-access-modal--required">*</span>
            </label>
            <div class="request-access-modal--textarea-wrapper">
              <textarea
                class="request-access-modal--textarea"
                [(ngModel)]="purposeDescription"
                placeholder="Please briefly describe how you plan to use this asset"
                rows="4"
                maxlength="200"
              ></textarea>
              <span class="request-access-modal--char-count">{{ purposeDescriptionLength }}/200 character limit</span>
            </div>
          </div>
          <div class="request-access-modal--field request-access-modal--checkbox-row">
            <input
              type="checkbox"
              id="request-access-agree"
              [(ngModel)]="agreeToTerms"
              class="request-access-modal--checkbox"
            />
            <label for="request-access-agree" class="request-access-modal--checkbox-label">
              I have read the
              <a
                href="/documents/Data%20Usage%20Agreement.pdf"
                download="Data Usage Agreement.pdf"
                class="request-access-modal--link"
                (click)="$event.stopPropagation()"
              >Data Usage Agreement</a>
              and agree with Terms of Service and Privacy Policy of MahaAgX
            </label>
          </div>
          <div class="request-access-modal--actions">
            <button type="button" class="request-access-modal--cancel-btn" (click)="onClose()">
              Cancel
            </button>
            <button
              type="button"
              class="request-access-modal--submit-btn"
              [disabled]="!isFormValid"
              (click)="onSubmit()"
            >
              Request Access
            </button>
          </div>
        </ng-container>
      </ng-container>

      <!-- User has organisation: show Organisation Name (readonly) + Purpose + checkbox + buttons -->
      <ng-container *ngIf="userHasOrganisation">
        <div class="request-access-modal--field request-access-modal--field-first">
          <label class="request-access-modal--label">
            Organisation Name
            <span class="request-access-modal--info-icon" title="Your organisation from your profile">i</span>
          </label>
          <input
            type="text"
            class="request-access-modal--input"
            [ngModel]="organisationName"
            [readonly]="true"
            placeholder="Enter organisation name"
          />
        </div>
        <div class="request-access-modal--field">
          <label class="request-access-modal--label">
            Purpose
            <span class="request-access-modal--required">*</span>
          </label>
          <div class="request-access-modal--textarea-wrapper">
            <textarea
              class="request-access-modal--textarea"
              [(ngModel)]="purposeDescription"
              placeholder="Please briefly describe how you plan to use this asset"
              rows="4"
              maxlength="200"
            ></textarea>
            <span class="request-access-modal--char-count">{{ purposeDescriptionLength }}/200 character limit</span>
          </div>
        </div>
        <div class="request-access-modal--field request-access-modal--checkbox-row">
          <input
            type="checkbox"
            id="request-access-agree-org"
            [(ngModel)]="agreeToTerms"
            class="request-access-modal--checkbox"
          />
          <label for="request-access-agree-org" class="request-access-modal--checkbox-label">
            I have read the
            <a
              href="/documents/Data%20Usage%20Agreement.pdf"
              download="Data Usage Agreement.pdf"
              class="request-access-modal--link"
              (click)="$event.stopPropagation()"
            >Data Usage Agreement</a>
            and agree with Terms of Service and Privacy Policy of MahaAgX
          </label>
        </div>
        <div class="request-access-modal--actions">
          <button type="button" class="request-access-modal--cancel-btn" (click)="onClose()">
            Cancel
          </button>
          <button
            type="button"
            class="request-access-modal--submit-btn"
            [disabled]="!isFormValid"
            (click)="onSubmit()"
          >
            Request Access
          </button>
        </div>
      </ng-container>

    </div>
  </div>
</app-modal>
